import { Compartment } from '@codemirror/state';
import { EditorView, placeholder } from '@codemirror/view';
import { type MutableRefObject } from 'react';

/**
 * Configures the placeholder functionality on the editor.
 * @param placeholderText - string to be used as placeholder text for editor
 * @param viewRef - Ref object for the editor
 * @param placeholderCompartment -
 */
export const configurePlaceholder = (
  placeholderText: string | undefined,
  viewRef: MutableRefObject<EditorView>,
  placeholderCompartment: Compartment,
): void => {
  const editorView = viewRef.current;
  editorView.dispatch({
    effects: placeholderCompartment.reconfigure(
      placeholderText ? placeholder(placeholderText) : [],
    ),
  });
};
